import { getAuth } from 'firebase/auth'
import React, { useState, useEffect }  from 'react'
import {useNavigate} from 'react-router-dom'

export interface IAuthRouteProps {
    children: React.ReactNode 
 }

const AuthRoute: React.FunctionComponent<IAuthRouteProps> = (props) => {
    const { children } = props
    const auth = getAuth()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
          if (user) {
            setLoading(false)
          } else {
            console.log("UnAuthorized")
            navigate('/')
          }
        });
    
        return unsubscribe;
      }, []);

    if(loading) return (<p>loading..</p>)

    return (
        <>{children}</>
    )
}

export default AuthRoute